import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowUpSquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowUpSquare"><Path d="M20.5 3.5H3.5V20.5H20.5V3.5Z" stroke="currentColor"/><Path d="M12 16.5V8" stroke="currentColor" strokeLinecap="square"/><Path d="M8.5 11L12 7.5L15.5 11" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowUpSquare;
